import React from 'react';

const color = (r) => (r >= 180 ? 'bg-green-600' : r >= 120 ? 'bg-emerald-500' : r >= 100 ? 'bg-yellow-400' : 'bg-red-500');
const text = (r) => (r >= 180 ? 'text-green-700' : r >= 120 ? 'text-emerald-700' : r >= 100 ? 'text-yellow-700' : 'text-red-600');

export function AchievementBar({ rate }) {
  if (rate === null || rate === undefined) return <span className="block text-center text-xs text-gray-400">Hedef yok</span>;
  const r = parseFloat(rate);
  return (
    <div className="flex items-center gap-2 min-w-[140px]">
      <div className="flex-1 h-2.5 bg-gray-200 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-500 ${color(r)}`} style={{ width: `${Math.min(r, 100)}%` }} />
      </div>
      <span className={`text-xs font-bold w-12 text-right ${text(r)}`}>%{r.toFixed(1)}</span>
    </div>
  );
}
